import { lazy } from 'react';

export const GmpAddRecord = lazy(() => import('./AddRecord/AddRecord'));
export const GmpViewRecord = lazy(() => import('./ViewRecord/ViewRecord'));
export const GmpEditRecord = lazy(() => import('./EditRecord/EditRecord'));
export const GmpViewProducerTransactions = lazy(
  () => import('./ViewProducerTransactions/ViewProducerTransactions')
);
